import { getProposalDemandDefaults, PROPOSAL_DATES } from '@/constants/proposalBuilder';

export const formatRub = (value) => `${new Intl.NumberFormat('ru-RU').format(Math.round(value))} ₽`;

export const getDefaultValidUntil = () => {
  const date = new Date();
  date.setDate(date.getDate() + PROPOSAL_DATES.validForDays);
  return date.toISOString().slice(0, 10);
};

export const formatDateRu = (value) => new Date(`${value}${PROPOSAL_DATES.noonOffset}`).toLocaleDateString('ru-RU');

export const locationsWord = (count) => {
  if (count % 10 === 1 && count % 100 !== 11) return 'заведение';
  const forms = [2, 3, 4];
  const exceptions = [12, 13, 14];
  if (forms.includes(count % 10) && !exceptions.includes(count % 100)) return 'заведения';
  return 'заведений';
};

export const distribute = (total, count) => Array.from(
  { length: count },
  (_, index) => Math.floor(total / count) + (index < total % count ? 1 : 0),
);

export const createVenue = (index, waiters, training) => ({
  name: `Заведение ${index + 1}`,
  waiters,
  training,
});

export const buildInitialVenues = () => [
  { name: 'Ресторан «Центр»', waiters: 20, training: 45 },
  { name: 'Кафе «Парк»', waiters: 16, training: 40 },
  { name: 'Фудкорт', waiters: 12, training: 35 },
];

export const buildInitialProposalData = () => ({
  company: 'Restaurant Group',
  contact: 'Иван Петров',
  plan: 'expert',
  venues: buildInitialVenues(),
  annual: true,
  tips: true,
  validUntil: getDefaultValidUntil(),
  manager: '',
});

export const normalizeProposalData = (saved) => {
  const initial = buildInitialProposalData();

  if (!saved) return initial;
  if (saved.venues?.length) return { ...initial, ...saved, venues: saved.venues };

  const count = Math.max(1, saved.locations || 1);
  const plan = getProposalDemandDefaults(saved.plan || 'business');
  const waiters = distribute(saved.waiters ?? plan.waiters * count, count);
  const training = distribute(saved.training ?? plan.training * count, count);

  return {
    ...initial,
    ...saved,
    venues: Array.from({ length: count }, (_, index) => createVenue(index, waiters[index], training[index])),
  };
};

export const serializeProposalData = (data) => JSON.stringify(data);

export const parseProposalData = (raw) => {
  if (!raw) return buildInitialProposalData();

  try {
    return normalizeProposalData(JSON.parse(raw));
  } catch {
    return buildInitialProposalData();
  }
};
